<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="partners">
    <div class="partners-title padding title">
      Наши партнеры
    </div>

    <div class="partners-list">
      <div
        v-for="(partner, index) in partners"
        :key="index"
        class="partner-item"
      >
        <div
          class="partner-card"
          :style="{ backgroundColor: partner.backgroundColor }"
          @click="handlePartnerClick(partner)"
        >
          <div class="partner-image-container">
            <img
              :src="partner.image"
              :alt="partner.name"
              class="partner-image"
              :style="{
                width: partner.imageWidth || 'auto',
                height: partner.imageHeight || 'auto'
              }"
            />
          </div>
        </div>
        <div class="partner-text">
          {{ partner.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useUserStore } from '@/stores/user/userStore'
import { getTelegramUser } from '@/helpers/telegram'

const userTg = getTelegramUser()
const user = useUserStore()

const partners = ref([
  {
    name: 'GetResult',
    image: require('../../images/partners/getresult-logo.svg'),
    text: 'GetResult - конструктор успеха Вашего бизнеса',
    backgroundColor: '#FFFFFF',
    link: 'https://getresult.io',
    imageWidth: '160px',
    imageHeight: '80px'
  },
  {
    name: 'Ювелирный цех',
    image: require('../../images/partners/jeleweryZeh.svg'),
    text: 'Ювелирный цех - коворкинг и мастер классы',
    backgroundColor: '#FFFFFF',
    link: 'https://jzeh.ru/',
    imageWidth: '110px',
    imageHeight: '110px'
  }
])

const handlePartnerClick = (partner) => {
  if (partner.link) {
    window.open(partner.link, '_blank')
  }
}

onMounted(() => {
  if(userTg) user.setUser(userTg)

})
</script>

<style lang="scss" scoped>
.partners {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 10px;
}

.title {
  border-bottom: 2px solid white;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  padding: 10px 0;
}

.partners-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 20px;
  width: 100%;
}

.partner-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120px;
  .partner-card {
    width: 120px;
    height: 120px;
    border-radius: 25px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    cursor: pointer;

    .partner-image-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .partner-image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
  }

  .partner-text {
    margin-top: 12px;
    color: #ffffff;
    font-size: 12px;
    text-align: center;
    line-height: 1.4;
    width: 100%;
  }
}
</style>
